const initialState = {
  newCbpAuth: false,
  cboAthId: '',
  dayQuantity: '',
  authStartDate: '',
  authEndDate: '',
};
export default initialState;
